<div class="d-flex text-center banner-patient">
    <div>
        <div>
            <h1 class="title-cta font-color-secundary">PORTAL DO PACIENTE</h1>
        </div>
    </div>
</div>